import { LoadingContext } from "@/providers/LoadingProvider";
import { useContext } from "react";

export function useLoadingScreen() {
  const loader = useContext(LoadingContext);
  if (loader === undefined) {
    throw new Error("useLoadingScreen must be used within a LoadingProvider");
  }
  return loader;
}
